<template>
  <Legacy
    view="reports"
    action="accounts"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Account Reports (Old)',
      breadcrumb: {
        name: 'Account Reports (Old)',
        route: { name: 'reports-legacy-accounts' }
      }
    }
  }
}
</script>
